import React from "react";

// create context to pass state variables from parent component to child component
const PageContext = React.createContext();

export default PageContext; 